angular.module('unica_notification.notification_services')

.factory('NotificationAssignService', function($http, getBaseApiURL) {

	var notificationAssignService = {};

	notificationAssignService.assign = function( eventId, notificationId, invitationsData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/assign/' + eventId + '/' + notificationId ,
			data: {
				invitations: invitationsData
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.notification_invitations;
			}

		});
	};

	notificationAssignService.list = function (eventId, notificationId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/assign-list/' + eventId + '/' + notificationId ,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.notification_invitations;
			}

		});
	};

	notificationAssignService.delete = function (notificationEmailId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/notification-group/assign-delete/' + notificationEmailId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return notificationAssignService;

});